import { IEntity } from '@pf/shared-common';
import {
    ResourceAuth,
    WarehouseFragment,
    ZoneLocationIdentifierViewModel,
    ZoneSearchRequestParams,
    ZoneViewModelCreateBody,
    ZoneViewModelRead,
} from '@control-tower/platform-wms';
import { ICustomFieldDto } from '@pf/shared/util-platform';
import { SlotDto } from './slot.dto';
import { isTempId } from '@pf/shared-utility';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';

export type ZoneRead = ZoneViewModelRead & IEntity;
export type ZoneCreate = ZoneViewModelCreateBody;
export type ZoneSearchParams = ZoneSearchRequestParams;

export function isLocationIdentifier(
    zone: ZoneRead | ZoneDto | null | undefined
): boolean {
    return isTempId(zone?.id);
}

export class ZoneDto implements IWarehouseEntity {
    constructor(data: Partial<ZoneDto>) {
        Object.assign(this, data);
        this.locationIdentifiers = data.locationIdentifiers || [];
    }
    id!: string;
    warehouseId!: string;
    warehouse!: WarehouseFragment;

    barcode?: string;
    description?: string;
    zonePriority?: number;
    resourceAuth?: ResourceAuth;
    name?: string;
    createdDate?: string;
    modifiedDate?: string;
    isDeleted?: boolean;
    locationIdentifiers: Array<ZoneLocationIdentifierViewModel>;
    slots?: Array<SlotDto>;
    customFields?: Array<ICustomFieldDto>;
}
